import { BestOfSubmissionWriteResponse } from 'app/features/BestOf/types';
import { BestOfApiError } from 'services/best-of';

export type BestOfSubmissionIntent = 'save_draft' | 'submit';

export interface BestOfSubmissionFormContext {
  year: number;
  submissionUuid?: string;
  contentVersion?: number;
  state?: 'draft' | 'submitted';
  readOnly?: boolean;
  initialCategoryUuid?: string;
  errorMessage?: string | null;
  onPreviewChange?: (isPreviewing: boolean) => void;
  onSaved: (response: BestOfSubmissionWriteResponse) => void;
  onFailure: (error: BestOfApiError) => void;
}

interface CategoryResource {
  resource_submission_category_uuid?: string | null;
  resource_submission_category?: { uuid?: string | null } | null;
}

interface CategoryFormData {
  resource_submission_category_uuid?: string | null;
}

export const resolveBestOfSubmissionCategoryUuid = (
  existingResource: CategoryResource | undefined,
  context: Pick<BestOfSubmissionFormContext, 'initialCategoryUuid'> | undefined,
  formData: CategoryFormData | undefined
) =>
  existingResource?.resource_submission_category_uuid ??
  existingResource?.resource_submission_category?.uuid ??
  context?.initialCategoryUuid ??
  formData?.resource_submission_category_uuid ??
  null;

export type ResourceSubmissionValues = Record<string, unknown>;

export const withBestOfSubmissionMetadata = (
  values: ResourceSubmissionValues,
  context: BestOfSubmissionFormContext,
  intent: BestOfSubmissionIntent
) => ({
  ...values,
  best_of: context.year,
  submission_intent: intent,
  draft: intent === 'save_draft',
  ...(context.submissionUuid && {
    best_of_submission_uuid: context.submissionUuid,
    content_version: context.contentVersion,
  }),
});
